import axios from 'axios'
import qs from 'qs'

let baseUrl = process.env.NODE_ENV == 'development' ? 'https://open-test.wehome.net.cn/api/v1/' : 'https://open-api.wehome.net.cn/api/v1/'
const service = axios.create({
  baseURL:  baseUrl,// 'https://open-api.wehome.net.cn/api/v1/', // url = base url + request url
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 20000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
	 
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  error => {
    console.log('err' + error) // for debug
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

const request = (url, data, type = 0) => {
  if (type === 0) {
    return service({
      url,
      method: 'post',
      data
    })
  } else {
    return service({
      url,
      method: 'get',
      params: {
        ...data
      }
    })
  }
}

export default request
